export default "__VITE_ASSET__I$2qvvsJ__"